import { createFileRoute } from "@tanstack/react-router";
import { useGetTransferPolicy } from "../hooks/api/";
import { useUpdateCustomerData } from "../hooks/ui";
import { isFullCredentials } from "../hooks/ui/customerDataStore";
import ErrorComponent from "../components/errorComponent";
import { TransferStatus } from "../components/transfer/transferStatus";

export const Route = createFileRoute("/transfer-status")({
  component: RouteComponent,
});

function RouteComponent() {
  const { customerData } = useUpdateCustomerData();
  const {
    data: advice,
    isLoading,
    isFetching,
    isError,
  } = useGetTransferPolicy({
    credentials: customerData.credentials,
    enabled: isFullCredentials(customerData.credentials),
  });

  if (isError) {
    return <ErrorComponent />;
  }

  return (
    <TransferStatus
      advice={advice}
      isFetching={isFetching}
      isLoading={isLoading}
    />
  );
}
